import React from 'react';

// Import translation
import i18n from 'i18next';

export const slug_info = <div>{i18n.t('institutions:slug_info')}</div>;
